import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import ModuleAccessManagement from '../../components/ModuleAccessManagement';
import { camasirhaneApi } from '../../api/camasirhaneApi';

const CamasirhaneAccessPage = () => (
  <ModuleAccessManagement
    title="Çamaşırhane Modül Erişimi"
    description="Çamaşırhane modülünü görebilecek ve kullanabilecek kullanıcıları seçin."
    api={camasirhaneApi}
    accent="orange"
    icon={SparklesIcon}
  />
);

export default CamasirhaneAccessPage;
